import React, { useState } from "react";

let useNavigate;
try { useNavigate = require("react-router-dom").useNavigate; }
catch { useNavigate = () => (path) => { window.location.href = path; }; }

let ameonLogo = null;
try { ameonLogo = require("../ameon.jpg"); } catch {}
const LOGO_SRC = ameonLogo || "/logo192.png";

const API_BASE = process.env.REACT_APP_API_URL || "https://canada-billing.ameontech.com";

const GlobalStyles = () => (
  <style>{`
    @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');

    *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
    html { scroll-behavior: smooth; -webkit-font-smoothing: antialiased; }
    body {
      font-family: 'DM Sans', system-ui, sans-serif;
      color: #1a1a2e;
      background: linear-gradient(135deg, #f0f7ff 0%, #fff5f4 50%, #f5f3ff 100%);
      background-attachment: fixed;
      font-size: 15px;
      line-height: 1.6;
    }
    button { font-family: inherit; cursor: pointer; }
    input, select { font-family: inherit; font-size: 15px; }
    a { text-decoration: none; }

    :root {
      --blue: #4f8ef7;
      --blue-dark: #3a7ae8;
      --blue-light: #eff6ff;
      --blue-mid: #bfdbfe;
      --ink: #1a1a2e;
      --ink-muted: #555;
      --ink-faint: #888;
      --surface: #ffffff;
      --border: #f0f0f0;
      --border-strong: #e0e0e0;
      --green: #52c97e;
      --coral: #f97b6b;
      --purple: #a78bfa;
      --radius-sm: 8px;
      --radius-md: 12px;
      --radius-lg: 20px;
      --radius-xl: 28px;
      --text-xs: 12px;
      --text-sm: 13px;
      --text-base: 15px;
      --text-md: 16px;
      --text-lg: 18px;
    }

    @keyframes fadeUp {
      from { opacity: 0; transform: translateY(28px); }
      to   { opacity: 1; transform: translateY(0); }
    }
    @keyframes spin {
      to { transform: rotate(360deg); }
    }
    @keyframes pulseDot {
      0%, 100% { box-shadow: 0 0 0 0 rgba(82,201,126,0.5); }
      50%       { box-shadow: 0 0 0 8px rgba(82,201,126,0); }
    }

    .signup-card { animation: fadeUp 0.65s cubic-bezier(.22,.9,.36,1) both; }
    .signup-side  { animation: fadeUp 0.65s cubic-bezier(.22,.9,.36,1) 0.1s both; }

    .form-input {
      width: 100%;
      padding: 12px 15px;
      border: 1.5px solid var(--border-strong);
      border-radius: var(--radius-md);
      font-family: 'DM Sans', sans-serif;
      font-size: var(--text-base);
      color: var(--ink);
      background: white;
      transition: border-color 0.2s, box-shadow 0.2s;
      outline: none;
    }
    .form-input:focus {
      border-color: var(--blue);
      box-shadow: 0 0 0 3px rgba(79,142,247,.12);
    }
    .form-input::placeholder { color: var(--ink-faint); }

    .btn-signup {
      width: 100%;
      padding: 14px;
      border-radius: 50px;
      border: none;
      background: linear-gradient(135deg, var(--blue), #6366f1);
      color: #fff;
      font-family: 'DM Sans', sans-serif;
      font-size: var(--text-base);
      font-weight: 600;
      cursor: pointer;
      transition: transform 0.2s, box-shadow 0.2s, opacity 0.2s;
      box-shadow: 0 4px 20px rgba(79,142,247,0.35);
      display: flex; align-items: center; justify-content: center; gap: 8px;
    }
    .btn-signup:hover:not(:disabled) { transform: translateY(-2px); box-shadow: 0 8px 30px rgba(79,142,247,0.45); }
    .btn-signup:disabled { opacity: 0.6; cursor: not-allowed; transform: none; }

    .plan-radio { display: none; }
    .plan-label {
      display: flex; flex-direction: column;
      border: 2px solid var(--border-strong);
      border-radius: var(--radius-md);
      padding: 14px 14px 12px;
      cursor: pointer;
      transition: border-color 0.2s, background 0.2s, box-shadow 0.2s;
      position: relative;
    }
    .plan-label:hover { border-color: var(--blue); background: var(--blue-light); }
    .plan-radio:checked + .plan-label {
      border-color: var(--blue);
      background: var(--blue-light);
      box-shadow: 0 0 0 3px rgba(79,142,247,0.15);
    }
    .plan-radio:checked + .plan-label .plan-check { opacity: 1; }
    .plan-check {
      position: absolute; top: 10px; right: 10px;
      width: 18px; height: 18px; background: var(--blue); border-radius: 50%;
      display: flex; align-items: center; justify-content: center;
      color: white; font-size: 10px; font-weight: 700;
      opacity: 0; transition: opacity 0.2s;
    }

    .pulse-dot {
      width: 8px; height: 8px; background: var(--green);
      border-radius: 50%; display: inline-block;
      animation: pulseDot 2s infinite;
    }

    @media (max-width: 900px) {
      .signup-side-panel { display: none !important; }
      .signup-main { padding: 32px 20px !important; }
      .plans-row { grid-template-columns: 1fr 1fr !important; }
    }
    @media (max-width: 480px) {
      .plans-row { grid-template-columns: 1fr 1fr !important; }
      .name-row  { grid-template-columns: 1fr !important; }
    }
  `}</style>
);

const PLANS = [
  { key: "basic",        name: "Basic",         price: "$9/mo",  target: "Freelancers",     color: "#4f8ef7" },
  { key: "professional", name: "Professional",  price: "$19/mo", target: "Small Biz",       color: "#f97b6b" },
  { key: "business_pro", name: "Business Pro",  price: "$39/mo", target: "SMEs & Agencies", color: "#a78bfa" },
];

export default function SignupPage() {
  const navigate = useNavigate();
  const [form, setForm] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    password: "",
    confirmPassword: "",
    plan: "professional",
  });
  const [showPass, setShowPass]        = useState(false);
  const [showConfirm, setShowConfirm]  = useState(false);
  const [isLoading, setIsLoading]      = useState(false);
  const [error, setError]              = useState("");
  const [success, setSuccess]          = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    if (error) setError("");
  };

  const validate = () => {
    if (!form.first_name.trim())                return "Please enter your first name.";
    if (!form.last_name.trim())                 return "Please enter your last name.";
    if (!form.email.trim())                     return "Please enter your email address.";
    if (!/\S+@\S+\.\S+/.test(form.email))      return "Please enter a valid email address.";
    if (!form.phone.trim())                     return "Please enter your phone number.";
    if (form.password.length < 8)               return "Password must be at least 8 characters.";
    if (form.password !== form.confirmPassword) return "Passwords do not match.";
    if (!form.plan)                             return "Please select a plan.";
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const err = validate();
    if (err) { setError(err); return; }

    setIsLoading(true);
    setError("");

    const fullName = `${form.first_name.trim()} ${form.last_name.trim()}`;

    try {
      const res = await fetch(`${API_BASE}/api/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name:       fullName,
          first_name: form.first_name.trim(),
          last_name:  form.last_name.trim(),
          email:      form.email.trim(),
          phone:      form.phone.trim(),
          password:   form.password,
          plan:       form.plan,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || "Signup failed. Please try again.");
        return;
      }

      localStorage.setItem("token",    data.token);
      localStorage.setItem("user",     JSON.stringify(data.user));
      localStorage.setItem("tenantId", data.tenant?.id || "");

      setSuccess(true);
    } catch {
      setError("Could not connect to server. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  // ── SUCCESS SCREEN ──
  if (success) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "linear-gradient(135deg, #f0f7ff 0%, #fff5f4 50%, #f5f3ff 100%)", padding: 24 }}>
        <GlobalStyles />
        <div style={{ textAlign: "center", maxWidth: 440 }}>
          <div style={{ width: 80, height: 80, background: "linear-gradient(135deg, #52c97e, #34d399)", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 24px", fontSize: 36, boxShadow: "0 8px 32px rgba(82,201,126,0.3)" }}>✓</div>
          <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 32, fontWeight: 800, color: "var(--ink)", marginBottom: 12, letterSpacing: "-0.5px" }}>
            Welcome to InvoiceCloud!
          </h2>
          <p style={{ fontFamily: "'DM Sans', sans-serif", color: "var(--ink-muted)", fontSize: 15, lineHeight: 1.7, marginBottom: 32 }}>
            Your account has been created successfully. Please sign in to get started.
          </p>
          <button
            onClick={() => navigate("/login")}
            style={{
              background: "linear-gradient(135deg, var(--blue), #6366f1)", color: "white", border: "none",
              borderRadius: 50, padding: "14px 36px",
              fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: 15, cursor: "pointer",
              boxShadow: "0 4px 20px rgba(79,142,247,0.35)", transition: "transform 0.2s",
            }}
            onMouseEnter={e => e.currentTarget.style.transform = "translateY(-2px)"}
            onMouseLeave={e => e.currentTarget.style.transform = "none"}
          >
            Sign in now →
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: "100vh", display: "flex", background: "linear-gradient(135deg, #f0f7ff 0%, #fff5f4 50%, #f5f3ff 100%)" }}>
      <GlobalStyles />

      {/* ── LEFT SIDE PANEL ── */}
      <div className="signup-side-panel" style={{
        width: 380, flexShrink: 0,
        background: "linear-gradient(160deg, #1a1a2e 0%, #16213e 60%, #0d3b6e 100%)",
        display: "flex", flexDirection: "column", justifyContent: "space-between",
        padding: "48px 44px", position: "relative", overflow: "hidden",
      }}>
        <div style={{ position: "absolute", width: 350, height: 350, borderRadius: "50%", background: "#4f8ef7", filter: "blur(100px)", opacity: 0.12, top: -60, right: -60, pointerEvents: "none" }} />
        <div style={{ position: "absolute", width: 250, height: 250, borderRadius: "50%", background: "#a78bfa", filter: "blur(80px)", opacity: 0.1, bottom: -40, left: -40, pointerEvents: "none" }} />

        {/* Logo */}
        <div className="signup-side" style={{ display: "flex", alignItems: "center", gap: 10, cursor: "pointer", position: "relative", zIndex: 2 }}
          onClick={() => navigate("/")}>
          <img src={LOGO_SRC} alt="InvoiceCloud" style={{ width: 36, height: 36, borderRadius: 10, objectFit: "contain", border: "1px solid rgba(255,255,255,0.1)" }} onError={e => e.currentTarget.style.display = "none"} />
          <div>
            <div style={{ fontFamily: "'Playfair Display', serif", fontWeight: 700, fontSize: 22, color: "white", lineHeight: 1 }}>
              Invoice<span style={{ color: "#4f8ef7" }}>Cloud</span>
            </div>
            <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, fontWeight: 600, letterSpacing: "1.4px", color: "#4f8ef7", textTransform: "uppercase" }}>Canada</div>
          </div>
        </div>

        {/* Middle content */}
        <div className="signup-side" style={{ position: "relative", zIndex: 2 }}>
          <div style={{ display: "inline-flex", alignItems: "center", gap: 8, background: "rgba(255,255,255,0.06)", border: "1px solid rgba(255,255,255,0.1)", padding: "6px 14px", borderRadius: 50, marginBottom: 20 }}>
            <span className="pulse-dot" />
            <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 12, color: "rgba(255,255,255,0.7)" }}>14-day free trial</span>
          </div>
          <h2 style={{ fontFamily: "'Playfair Display', serif", fontSize: 30, fontWeight: 800, color: "white", lineHeight: 1.2, letterSpacing: "-0.5px", marginBottom: 14 }}>
            Start billing professionally today
          </h2>
          <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 14, color: "rgba(255,255,255,0.5)", lineHeight: 1.75, marginBottom: 28 }}>
            No credit card required. Cancel anytime.
          </p>
          {[
            "GST/HST/PST auto-calculations",
            "CRA-compliant invoicing",
            "Payroll & T4 slip generation",
            "Stripe payment integration",
            "Bank-level 256-bit security",
          ].map((text, i) => (
            <div key={i} style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
              <div style={{ width: 20, height: 20, background: "rgba(82,201,126,0.2)", border: "1px solid rgba(82,201,126,0.3)", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                <span style={{ color: "#52c97e", fontSize: 10, fontWeight: 700 }}>✓</span>
              </div>
              <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: "rgba(255,255,255,0.65)" }}>{text}</span>
            </div>
          ))}
        </div>

        {/* Bottom quote */}
        <div className="signup-side" style={{ position: "relative", zIndex: 2 }}>
          <div style={{ background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 16, padding: "18px 20px" }}>
            <p style={{ fontFamily: "'Playfair Display', serif", fontStyle: "italic", color: "rgba(255,255,255,0.6)", fontSize: 13, lineHeight: 1.7, marginBottom: 12 }}>
              "Set up in 5 minutes. First invoice sent same day."
            </p>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <div style={{ width: 32, height: 32, background: "linear-gradient(135deg, #4f8ef7, #6366f1)", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontWeight: 800, fontSize: 13 }}>O</div>
              <div>
                <p style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 600, fontSize: 12, color: "white" }}>Omkar Joshi</p>
                <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, color: "rgba(255,255,255,0.4)" }}>Founder, InvoiceCloud Canada</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── RIGHT SIGNUP FORM ── */}
      <div className="signup-main" style={{
        flex: 1, display: "flex", alignItems: "flex-start", justifyContent: "center",
        padding: "48px 40px", overflowY: "auto", position: "relative",
      }}>
        <div style={{ position: "absolute", width: 350, height: 350, borderRadius: "50%", background: "#4f8ef7", filter: "blur(100px)", opacity: 0.05, top: -60, right: -60, pointerEvents: "none" }} />

        <div className="signup-card" style={{ width: "100%", maxWidth: 460, position: "relative", zIndex: 2, paddingTop: 8 }}>

          <div style={{ marginBottom: 28 }}>
            <h1 style={{ fontFamily: "'Playfair Display', serif", fontSize: "clamp(24px,3vw,32px)", fontWeight: 800, color: "var(--ink)", letterSpacing: "-0.5px", marginBottom: 8, lineHeight: 1.15 }}>
              Create your account
            </h1>
            <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "var(--text-base)", color: "var(--ink-muted)" }}>
              Start your 14-day free trial — no credit card needed.
            </p>
          </div>

          {/* Error */}
          {error && (
            <div style={{
              background: "#fef2f2", border: "1px solid #fecaca",
              borderRadius: "var(--radius-md)", padding: "12px 16px",
              marginBottom: 20, display: "flex", alignItems: "center", gap: 10,
              fontFamily: "'DM Sans', sans-serif", fontSize: "var(--text-sm)", color: "#991b1b",
            }}>
              <span>❌</span> {error}
            </div>
          )}

          <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>

            {/* First Name + Last Name */}
            <div className="name-row" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              <div>
                <label style={{ display: "block", fontFamily: "'DM Sans', sans-serif", fontSize: "var(--text-sm)", fontWeight: 600, color: "var(--ink)", marginBottom: 6 }}>
                  First Name
                </label>
                <input
                  className="form-input"
                  type="text"
                  name="first_name"
                  placeholder="Omkar"
                  value={form.first_name}
                  onChange={handleChange}
                  disabled={isLoading}
                  autoComplete="given-name"
                />
              </div>
              <div>
                <label style={{ display: "block", fontFamily: "'DM Sans', sans-serif", fontSize: "var(--text-sm)", fontWeight: 600, color: "var(--ink)", marginBottom: 6 }}>
                  Last Name
                </label>
                <input
                  className="form-input"
                  type="text"
                  name="last_name"
                  placeholder="Joshi"
                  value={form.last_name}
                  onChange={handleChange}
                  disabled={isLoading}
                  autoComplete="family-name"
                />
              </div>
            </div>

            {/* Email + Phone */}
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              <div>
                <label style={{ display: "block", fontFamily: "'DM Sans', sans-serif", fontSize: "var(--text-sm)", fontWeight: 600, color: "var(--ink)", marginBottom: 6 }}>
                  Email Address
                </label>
                <input
                  className="form-input"
                  type="email"
                  name="email"
                  placeholder="you@company.ca"
                  value={form.email}
                  onChange={handleChange}
                  disabled={isLoading}
                  autoComplete="email"
                />
              </div>
              <div>
                <label style={{ display: "block", fontFamily: "'DM Sans', sans-serif", fontSize: "var(--text-sm)", fontWeight: 600, color: "var(--ink)", marginBottom: 6 }}>
                  Phone Number
                </label>
                <input
                  className="form-input"
                  type="tel"
                  name="phone"
                  placeholder="+1 (416) 000-0000"
                  value={form.phone}
                  onChange={handleChange}
                  disabled={isLoading}
                  autoComplete="tel"
                />
              </div>
            </div>

            {/* Password */}
            <div>
              <label style={{ display: "block", fontFamily: "'DM Sans', sans-serif", fontSize: "var(--text-sm)", fontWeight: 600, color: "var(--ink)", marginBottom: 6 }}>
                Password <span style={{ color: "var(--ink-faint)", fontWeight: 400 }}>(min. 8 characters)</span>
              </label>
              <div style={{ position: "relative" }}>
                <input
                  className="form-input"
                  type={showPass ? "text" : "password"}
                  name="password"
                  placeholder="Create a strong password"
                  value={form.password}
                  onChange={handleChange}
                  disabled={isLoading}
                  autoComplete="new-password"
                  style={{ paddingRight: 48 }}
                />
                <button type="button" onClick={() => setShowPass(!showPass)}
                  style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "var(--ink-faint)", fontSize: 16, padding: 0 }}>
                  {showPass ? "🙈" : "👁️"}
                </button>
              </div>
            </div>

            {/* Confirm Password */}
            <div>
              <label style={{ display: "block", fontFamily: "'DM Sans', sans-serif", fontSize: "var(--text-sm)", fontWeight: 600, color: "var(--ink)", marginBottom: 6 }}>
                Confirm Password
              </label>
              <div style={{ position: "relative" }}>
                <input
                  className="form-input"
                  type={showConfirm ? "text" : "password"}
                  name="confirmPassword"
                  placeholder="Re-enter your password"
                  value={form.confirmPassword}
                  onChange={handleChange}
                  disabled={isLoading}
                  autoComplete="new-password"
                  style={{ paddingRight: 48 }}
                />
                <button type="button" onClick={() => setShowConfirm(!showConfirm)}
                  style={{ position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", color: "var(--ink-faint)", fontSize: 16, padding: 0 }}>
                  {showConfirm ? "🙈" : "👁️"}
                </button>
              </div>
              {form.confirmPassword && (
                <p style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, marginTop: 5, color: form.password === form.confirmPassword ? "#52c97e" : "#f97b6b" }}>
                  {form.password === form.confirmPassword ? "✓ Passwords match" : "✗ Passwords don't match"}
                </p>
              )}
            </div>

            {/* Plan selection */}
            <div>
              <label style={{ display: "block", fontFamily: "'DM Sans', sans-serif", fontSize: "var(--text-sm)", fontWeight: 600, color: "var(--ink)", marginBottom: 10 }}>
                Choose Your Plan <span style={{ color: "var(--blue)", fontWeight: 500 }}>(14-day free trial on all)</span>
              </label>
              <div className="plans-row" style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8 }}>
                {PLANS.map((plan) => (
                  <div key={plan.key} style={{ position: "relative" }}>
                    <input
                      type="radio"
                      className="plan-radio"
                      id={`plan-${plan.key}`}
                      name="plan"
                      value={plan.key}
                      checked={form.plan === plan.key}
                      onChange={handleChange}
                      disabled={isLoading}
                    />
                    <label htmlFor={`plan-${plan.key}`} className="plan-label">
                      <div className="plan-check">✓</div>
                      <div style={{ width: 8, height: 8, borderRadius: "50%", background: plan.color, marginBottom: 6, flexShrink: 0 }} />
                      <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 12, fontWeight: 700, color: "var(--ink)", lineHeight: 1.2, marginBottom: 3 }}>{plan.name}</span>
                      <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 11, color: plan.color, fontWeight: 600 }}>{plan.price}</span>
                      <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 10, color: "var(--ink-faint)", marginTop: 2 }}>{plan.target}</span>
                    </label>
                  </div>
                ))}
              </div>
            </div>

            {/* Submit */}
            <div style={{ marginTop: 4 }}>
              <button type="submit" className="btn-signup" disabled={isLoading}>
                {isLoading
                  ? <><span style={{ width: 16, height: 16, border: "2px solid rgba(255,255,255,.4)", borderTopColor: "#fff", borderRadius: "50%", display: "inline-block", animation: "spin .7s linear infinite" }} /> Creating account...</>
                  : "Start free trial →"
                }
              </button>
              <p style={{ textAlign: "center", fontFamily: "'DM Sans', sans-serif", fontSize: 11, color: "var(--ink-faint)", marginTop: 10 }}>
                No credit card required · Cancel anytime
              </p>
            </div>
          </form>

          {/* Divider + login link */}
          <div style={{ display: "flex", alignItems: "center", gap: 12, margin: "20px 0 16px" }}>
            <div style={{ flex: 1, height: 1, background: "var(--border-strong)" }} />
            <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: "var(--text-xs)", color: "var(--ink-faint)", fontWeight: 500 }}>ALREADY HAVE AN ACCOUNT?</span>
            <div style={{ flex: 1, height: 1, background: "var(--border-strong)" }} />
          </div>
          <button type="button"
            onClick={() => navigate("/login")}
            style={{
              width: "100%", padding: "12px", borderRadius: 50,
              border: "2px solid var(--border-strong)", background: "transparent",
              color: "var(--ink-muted)", fontFamily: "'DM Sans', sans-serif",
              fontSize: "var(--text-sm)", fontWeight: 500, cursor: "pointer",
              transition: "border-color 0.2s, color 0.2s",
            }}
            onMouseEnter={e => { e.currentTarget.style.borderColor = "var(--blue)"; e.currentTarget.style.color = "var(--blue)"; }}
            onMouseLeave={e => { e.currentTarget.style.borderColor = "var(--border-strong)"; e.currentTarget.style.color = "var(--ink-muted)"; }}
          >
            Sign in instead
          </button>

          {/* Legal */}
          <p style={{ textAlign: "center", fontFamily: "'DM Sans', sans-serif", fontSize: 11, color: "var(--ink-faint)", marginTop: 20, lineHeight: 1.7 }}>
            By creating an account, you agree to our{" "}
            <button type="button" onClick={() => navigate("/")} style={{ background: "none", border: "none", color: "var(--blue)", cursor: "pointer", fontSize: 11, padding: 0 }}>Terms</button>
            {" & "}
            <button type="button" onClick={() => navigate("/")} style={{ background: "none", border: "none", color: "var(--blue)", cursor: "pointer", fontSize: 11, padding: 0 }}>Privacy Policy</button>.
            <br />© 2026 InvoiceCloud Canada Inc. 🍁
          </p>
        </div>
      </div>
    </div>
  );
}